module.exports = __webpack_public_path__ + "static/media/add.34c370fb.svg";